import mainPageRedesign2026 from "./main-page-redesign-2026";
import discountExpeditorPro2026 from "./discount-expeditor-pro-2026";
import fsbSorm2026 from "./fsb-sorm-2026";
import skbKonturPartnership2026 from "./skb-kontur-partnership-2026";
import logoperPartnership2026 from "./logoper-partnership-2026";
import crossDocking2026 from "./cross-docking-2026";
import transrussia2026 from "./transrussia-2026";
import personalSupport2026 from "./personal-support-2026";
import hotline88002026 from "./hotline-8800-2026";
import svetoforeRuDomain2026 from "./svetofore-ru-domain-2026";

export const platformNewsDefinitions = Object.freeze([
    mainPageRedesign2026,
    discountExpeditorPro2026,
    fsbSorm2026,
    skbKonturPartnership2026,
    logoperPartnership2026,
    crossDocking2026,
    transrussia2026,
    personalSupport2026,
    hotline88002026,
    svetoforeRuDomain2026,
]);

function toCatalogItem({
    articleType,
    content,
    ...catalogItem
}) {
    return catalogItem;
}

export const platformNewsCatalog = Object.freeze(
    platformNewsDefinitions.map(toCatalogItem)
);

export const mainPageFeaturedNewsId = "fsb-sorm-2026";

const featuredNews = platformNewsCatalog.filter(
    (newsItem) => Boolean(newsItem.featured)
);

export const mainPagePlatformNewsCatalog = Object.freeze([
    ...featuredNews.filter(
        (newsItem) => newsItem.id === mainPageFeaturedNewsId
    ),
    ...featuredNews.filter(
        (newsItem) => newsItem.id !== mainPageFeaturedNewsId
    ),
]);

export const defaultPlatformNewsPath =
    `/news/${platformNewsCatalog[0].slug}`;
